import { useEffect } from 'react';
import { analyticsActions } from 'angieslist-app-platform';

type Props = {
  analyticsEventName: string,
  analyticsEventProperties: any,
  sendEnhancedTrackEvent:
    typeof analyticsActions.sendEnhancedTrackEvent,
};

const SendEnhancedTrackEventOnce = (props: Props) => {
  useEffect(() => {
    props.sendEnhancedTrackEvent({
      name: props.analyticsEventName,
      properties: props.analyticsEventProperties,
    });
  }, []);
  return null;
};

export default SendEnhancedTrackEventOnce;



// WEBPACK FOOTER //
// ./src/app/browser/SendEnhancedTrackEventOnce.js